import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/AllYoutubeCmsConfirmedChannels.graphql';
import { Query, QueryallYoutubeCmsConfirmedChannelsArgs } from '../../__generated__/globalTypes';

export const useAllYoutubeCmsConfirmedChannelsQuery = (
  options?: QueryHookOptions<Query, QueryallYoutubeCmsConfirmedChannelsArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryallYoutubeCmsConfirmedChannelsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useAllYoutubeCmsConfirmedChannelsLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryallYoutubeCmsConfirmedChannelsArgs>
): QueryResult<Query, QueryallYoutubeCmsConfirmedChannelsArgs> & {
  getAllYoutubeCmsConfirmedChannels: LazyQueryExecFunction<Query, QueryallYoutubeCmsConfirmedChannelsArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getAllYoutubeCmsConfirmedChannels, result] = useLazyQuery<Query, QueryallYoutubeCmsConfirmedChannelsArgs>(
    QUERY,
    {
      onError: (error) => {
        enqueueSnackbar(t(error.message), { variant: 'error' });
      },
      ...options
    }
  );

  return { getAllYoutubeCmsConfirmedChannels, ...result };
};

export const useAllYoutubeCmsConfirmedChannelsPromiseQuery = () => {
  const client = useApolloClient();

  const getAllYoutubeCmsConfirmedChannels = useCallback(
    (options?: Omit<QueryOptions<QueryallYoutubeCmsConfirmedChannelsArgs, Query>, 'query'>) =>
      client.query<Query, QueryallYoutubeCmsConfirmedChannelsArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getAllYoutubeCmsConfirmedChannels };
};
// Suspense Query Hooks
export const useAllYoutubeCmsConfirmedChannelsSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryallYoutubeCmsConfirmedChannelsArgs>
) => {
  const result = useSuspenseQuery<Query, QueryallYoutubeCmsConfirmedChannelsArgs>(QUERY, {
    ...options
  });

  return result;
};
